module.exports = __webpack_public_path__ + "img/美容水(蓝)_02.41636e25.jpg";